import { Avatar, Badge, Box, Chip, Grid, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { getApplicants, getCandidates, getSingleApplicantById, getSinglePostedJob } from "../../../../Redux/Reducers/JobReducer";
import { getOtherProfessionalInfo } from "../../../../Redux/Reducers/ProfileReducer";
import { getVisitingCardReducer } from "../../../../Redux/Reducers/CardReducer";

const CandidateCard = ({ candidate, viewMode = "grid" }) => {
  console.log("candidateNNNNNNN", candidate)
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCandidateClick = async (candidate) => {
    try {
      // const encryptedId = CryptoJS.AES.encrypt(
      //   candidate?.user_ref_id?.toString(),
      //   "UserDetailsSecretKey"
      // ).toString();
      // dispatch(getVisitingCardReducer({ encryptedId: encryptedId }));
      // dispatch(getSingleApplicantById(candidate?.application_id));
      // dispatch(getApplicants({job_id:candidate?.job_id}));
      // // dispatch(getCandidates());
      // dispatch(getOtherProfessionalInfo(candidate?.user_ref_id));
      // dispatch(getSinglePostedJob(candidate?.job_id));
      navigate(`/candidateSingle-page/${candidate?.application_id}`);
    } catch (error) {
      console.error("Error loading candidate data:", error);
    }
  };

  return (
    <Grid item xs={12} sm={6} md={4} lg={3} key={candidate?.id}>
      <Box
        onClick={() => handleCandidateClick(candidate)}
        sx={{
          cursor: "pointer",
          width: "180px",
          height: "220px",
          p: 2,
          borderRadius: 2,
          border: "2px solid #00000020",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          backgroundColor: "#fff",
          m: "auto",
          transition: "all 0.3s ease",
          "&:hover": { border: "1px solid #0044C6" },
        }}
      >
        <Badge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          badgeContent={
            <Avatar
              src={
                candidate?.latestExperience?.company_logo || candidate?.latestEducation?.institute_logo ||
                "https://i.pinimg.com/736x/ec/d9/c2/ecd9c2e8ed0dbbc96ac472a965e4afda.jpg"
              }
              sx={{
                width: 24,
                height: 24,
                border: "2px solid white",
              }}
            />
          }
        >
          <Avatar
            src={candidate?.profile_picture}
            alt={candidate?.name}
            sx={{ width: 60, height: 60, mb: 1 }}
          >
            {candidate?.name?.[0] || "?"}
          </Avatar>
        </Badge>
        <Typography
          sx={{
            color: "black",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          {candidate?.name}
        </Typography>
        <Typography sx={{ color: "black", fontSize: "12px" }}>
          {candidate?.latestExperience?.designation || candidate?.latestEducation?.degree }
        </Typography>
        <Typography sx={{ color: "black", fontSize: "12px" }}>
          {candidate?.latestExperience?.company_name || candidate?.latestEducation?.institute_name }
        </Typography>
        <Chip
          label={candidate?.status}
          color="success"
          variant="outlined"
          sx={{ mt: 1 }}
        />
      </Box>
    </Grid>
  );
};

export default CandidateCard;
